module.exports = function(libMap) {
    const MARKER_CONFIG = {
        className: 'od-custom-marker od-custom-marker-pin',
        width: 25,
        height: 37,
    };

    function Marker(options) {
        this.el = null;
        this.point = null;
        this.position = options.position;
        this.config = Odigeo._.extend({}, MARKER_CONFIG, options.config);
        this.setMap(options.map);
    }

    Marker.prototype = new libMap.OverlayView();

    Odigeo._.extend(Marker.prototype, {
        constructor: Marker,

        // @Override google.maps.OverlayView
        onAdd: function() {
            this.el = document.createElement('div');
            this.el.className = this.config.className;
            this.getPanes().overlayImage.appendChild(this.el);
        },

        // @Override google.maps.OverlayView
        draw: function() {
            this.point = this.getProjection().fromLatLngToDivPixel(this.position);
            this.el.style.left = (this.point.x - (this.config.width / 2)) + 'px';
            this.el.style.top = (this.point.y - this.config.height) + 'px';
        },

        // @Override google.maps.OverlayView
        onRemove: function() {
            this.el.parentNode.removeChild(this.el);
            this.el = null;
        },
    });

    return Marker;
};
